module.exports = __webpack_public_path__ + "static/img/XhorseApp-Home.4179487.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XhorseApp-Home.png
// module id = wSuc
// module chunks = 0